import {
  getImageURLBasedOnEvent,
  getVideoURLBasedOnEvent,
} from "constants/media";
import { API_HOST } from "utils";

const baseURL = `${API_HOST}/comm`;
const defaultKeyValues = {
  SOURCE: "PRE_EVENT",
  EVENT_ID: 0,
  BRANCH_ID: 1,
};

// const getImageURLBasedOnEvent = (event) => {
//   switch (event) {
//     case "Annual Day":
//       return "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/AnnualDay.jpg";
//     case "Science Fair":
//       return "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/ScienceFair.jpg";
//     case "Sports Day":
//       return "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/SportsDay.jpg";
//     default:
//       return "";
//   }
// };

// const getVideoURLBasedOnEvent = (event) => {
//   switch (event) {
//     case "Social Hub Intro":
//       return "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/intro.mp4";
//     case "Annual Day":
//       return "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/AnnualDay.mp4";
//     case "Science Fair":
//       return "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/ScienceFair.mp4";
//     case "Sports Day":
//       return "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/SportsDay.mp4";
//     default:
//       return "";
//   }
// };

const buildPayloads = (content, event) => ({
  facebookPost: {
    url: `${baseURL}/facebook/post`,
    payload: {
      TITLE: content?.text,
      IMAGES: { 0: getImageURLBasedOnEvent(event) },
      ...defaultKeyValues,
    },
  },
  instagramPost: {
    url: `${baseURL}/instagram/post`,
    payload: {
      CAPTION: content?.text,
      MEDIA_TYPE: "CAROUSEL",
      IMAGES: { 0: getImageURLBasedOnEvent(event) },
      ...defaultKeyValues,
    },
  },
  youtubePost: {
    url: `${baseURL}/youtube/post`,
    payload: {
      BRANCH_ID: 1,
      EVENT_DETAIL_ID: 0,
      VIDEO_URL: getVideoURLBasedOnEvent(event),
      TITLE: content?.structured_data?.title,
    },
  },
  facebookReel: {
    url: `${baseURL}/facebook/postReel`,
    payload: {
      TITLE: content?.text,
      EVENT_DETAIL_URL: getVideoURLBasedOnEvent(event),
      EVENT_DETAIL_ID: 0,
      ...defaultKeyValues,
    },
  },
  instagramReel: {
    url: `${baseURL}/instagram/postReel`,
    payload: {
      TITLE: content?.text,
      EVENT_DETAIL_URL: getVideoURLBasedOnEvent(event),
      EVENT_DETAIL_ID: 0,
      ...defaultKeyValues,
    },
  },
});

export default buildPayloads;
